module.exports = __webpack_public_path__ + "static/media/reply.fd0d3a99.svg";